import React from 'react';
import PropTypes from 'prop-types';

const formatters = {
    bold: {
        pattern: /(\*\*[^*]+\*\*)/,
        render: (content, key) => (
            <span style={{ fontWeight: 600 }} key={key}>
                {content.slice(2, -2)}
            </span>
        ),
    },
    italic: { pattern: /(\*[^*]+\*)/, render: (content, key) => <em key={key}>{content.slice(1, -1)}</em> },
    underline: { pattern: /(__[^_]+__)/, render: (content, key) => <u key={key}>{content.slice(2, -2)}</u> },
};

const FormattedText = ({ text = '', className = '' }) => {
    if (!text) return null;

    const renderFormattedText = inputText => {
        let result = [inputText];

        Object.keys(formatters).forEach(formatterKey => {
            const formatter = formatters[formatterKey];

            result = result.flatMap(part => {
                if (typeof part !== 'string') return part;

                const splitParts = part.split(formatter.pattern);
                return splitParts.map((segment, index) => {
                    if (formatter.pattern.test(segment)) {
                        return formatter.render(segment, `${formatterKey}-${index}`);
                    }
                    return segment;
                });
            });
        });

        return result.filter(part => part !== '');
    };

    return <span className={className}>{renderFormattedText(text)}</span>;
};

FormattedText.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
};

export default FormattedText;
